import { SolutionPageTemplate } from '@/components/SolutionPageTemplate';
import { BatteryCharging, Zap, Sun, BarChart3, Clock, Leaf } from 'lucide-react';

export default function EVChargingPage() {
  return (
    <SolutionPageTemplate
      slug="ev-charging"
      title="BESS for EV Charging"
      subtitle="EV Infrastructure"
      description="Overcome grid capacity limitations for EV charging with battery energy storage. Enable fast charging without expensive transformer upgrades."
      heroImage="/images/voltide-solar-ev.png"
      path="/solutions/ev-charging"
      sectorLabel="ev_charging"
      useCaseParam="dg_replacement"
      benefits={[
        { icon: BatteryCharging, title: 'Fast Charging', desc: 'Enable DC fast charging (50-150 kW) without grid upgrades using stored energy.' },
        { icon: Zap, title: 'No Grid Upgrade', desc: 'Avoid expensive and time-consuming transformer upgrades. BESS buffers the load.' },
        { icon: Sun, title: 'Solar + EV', desc: 'Charge vehicles with stored solar energy for truly zero-emission transport.' },
        { icon: BarChart3, title: 'Load Balancing', desc: 'Smart management of multiple charger loads prevents grid demand spikes.' },
        { icon: Clock, title: 'Revenue Ready', desc: 'Start earning from day one. Deploy faster than waiting for grid infrastructure.' },
        { icon: Leaf, title: 'Green Charging', desc: 'Offer carbon-neutral charging. Differentiate your charging network.' },
      ]}
      howItWorks={[
        { title: 'Charger Planning', desc: 'We assess your planned charger mix (AC/DC), daily throughput, and existing grid connection to size the BESS buffer.' },
        { title: 'Integrated Installation', desc: 'BESS deployed alongside chargers. Single control system manages battery and charger coordination.' },
        { title: 'Smart Dispatch', desc: 'EMS optimizes charging schedules, grid draw limits, and battery cycling for maximum uptime and minimum cost.' },
      ]}
      faqs={[
        { q: 'Can BESS support multiple DC fast chargers?', a: 'Yes. A 500 kW BESS can buffer 2-4 DC fast chargers, allowing them to operate at full power even when the grid connection is limited.' },
        { q: 'How does this reduce my electricity costs?', a: 'BESS charges during off-peak hours at lower tariffs and delivers power during peak charging demand. This arbitrage can save 20-30% on electricity costs.' },
        { q: 'What about locations with no grid connection?', a: 'Solar + BESS enables off-grid EV charging for remote locations, highway stops, and temporary events.' },
      ]}
      productFilter={p => p.pcs_kw >= 250}
    />
  );
}
